import { render } from "./bang.vue?vue&type=template&id=240d9e3a&scoped=true"
import script from "./bang.vue?vue&type=script&lang=js"
export * from "./bang.vue?vue&type=script&lang=js"

import "./bang.vue?vue&type=style&index=0&id=240d9e3a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240d9e3a"]])

export default __exports__